import BaseListPresenter from "../../../base/BaseListPresenter";
import { Button, dialog } from "nq-component";
import {
  buildHierarchyWhere,
  findCurrentUserEmployee,
} from "../../../utils/hierarchy";

class OBForApprovalPresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    deleteObjectUseCase,
    upsertUseCase,
    exportCSVUseCase,
    addSchemaUseCase,
    updateSchemaUseCase,
    deleteSchemaUseCase
  ) {
    super(view, findObjectUseCase, countObjectUseCase, deleteObjectUseCase);
    this.upsertUseCase = upsertUseCase;
    this.exportCSVUseCase = exportCSVUseCase;
    this.addSchemaUseCase = addSchemaUseCase;
    this.updateSchemaUseCase = updateSchemaUseCase;
    this.deleteSchemaUseCase = deleteSchemaUseCase;
    this.view = view;
  }

  init() {
    const user = this.view.getCurrentUser();

    this.limit = 10;
    this.where = { employee: { "supervisor.id": user.employee.id } };
    this.search = {};
    this.filter = {};
    this.include = ["all"];
    this.keys = undefined; // if keys are specified, only those keys will be returned
    this.sort = { Firstname: 1, Middlename: 1, Surname: 1 };
    this.progress = true;
    this.reset();
  }

  componentDidMount() {
    this.init();
    this.loadEmployeeWhere().then(() => this.getObjects());
  }

  async loadEmployeeWhere() {
    try {
      const employees = await findCurrentUserEmployee(
        this.findObjectUseCase,
        this.view.getCurrentUser(),
      );
      this.view.setWhere(buildHierarchyWhere(employees?.[0]));
    } catch (error) {
      this.view.setWhere({});
      this.view.showError(error);
    }
  }

  createQuery() {
    const skip = (this.current - 1) * this.limit;
    const query = {
      limit: this.limit,
      skip: skip,
      where: { ...this.where, ...this.search, ...this.filter },
      include: this.include,
    };

    if (this.sort) {
      query.sort = this.sort;
    }
    const keys = this.keys || this.view.getKeys() || [];
    if (keys.length > 0) {
      query.keys = keys;
    }
    return query;
  }

  async findObjects() {
    const collection = this.view.getCollectionName();
    const query = this.createQuery();
    try {
      this.showProgress();
      this.findObjectUseCase.abort();
      const objects = await this.findObjectUseCase.execute(collection, query);
      this.objects = this.objects.concat(objects);
      this.view.setObjects(objects);
      this.view.setCurrent(this.current);
      this.hideProgress();
    } catch (error) {
      this.hideProgress();
      this.view.showError(error);
    }
    this.progress = false;
  }

  setCurrentPage(page) {
    this.current = page;
    this.documents = [];
    this.view.setCurrent(page);
    this.view.setObjects([]);
    this.findObjects();
  }

  DialogConfirmation(title, message, onConfirm) {
    dialog.fire({
      html: (
        <div className="p-2">
          <div className="row p-1">
            <h4>{title}</h4>
            <hr />
            <p style={{ fontSize: "13px", padding: "1rem" }}>
              {message}
            </p>
            <hr />
          </div>
          <div className="w-100 d-flex justify-content-end gap-2 pe-3 pb-3">
            {onConfirm ? (
              <>
                <Button
                  className="btn btn-light fs-sm border-primary"
                  onClick={() => dialog.close()}
                >
                  Cancel
                </Button>
                <Button
                  className="btn btn-primary"
                  onClick={async () => {
                    dialog.close();
                    await onConfirm();
                  }}
                >
                  Confirm
                </Button>
              </>
            ) : (
              <Button
                className="btn btn-primary"
                onClick={() => dialog.close()}
              >
                OK
              </Button>
            )}
          </div>
        </div>
      ),
      footer: false,
    });
  }


  handleStatusChange(data, newStatus) {
    // if (data.status === newStatus) {
    //   let alreadyTitle = `Already ${newStatus}`;
    //   let alreadyMessage = `This OB request has already been ${newStatus.toLowerCase()}.`;
      
    //   if (newStatus === "Fowarded to Cebs") {
    //     alreadyTitle = "Already Forwarded to CEBS";
    //     alreadyMessage = "This OB request has already been forwarded to CEBS.";
    //   }
      
    //   this.DialogConfirmation(
    //     alreadyTitle,
    //     alreadyMessage
    //   );
    //   return;
    // }
  
    let title = `${newStatus} Request`;
    let message = `Are you sure you want to ${newStatus.toLowerCase()} this OB request? Click Confirm to continue!`;
    
    if (newStatus === "Forwarded to CEBS") {
      title = "Forward Request";
      message = "Are you sure you want to forward this OB request to CEBS? Click Confirm to continue!";
    }
  
    this.DialogConfirmation(
      title,
      message,
      () => this.handleApproval(data, newStatus)
    );
  }
  

  async handleApproval(data, status) {
    try {
      const collection = this.view.getCollectionName();

      const updatedObject = {
        id: data.id,
        status: status,
      }

      const { updatedAt, ...rest } = data;

      const fullObject = {
        ...rest,
        dateApproved: updatedAt,
        status,
        employee: { id: data.employee.id },
      };

      await this.upsertUseCase.execute("ob_management", fullObject);
      await this.upsertUseCase.execute(collection, updatedObject);
      const message = status === "Forwarded to CEBS" 
        ? "Successfully Approved!" 
        : "Successfully Disapproved!";
      this.view.showSuccess(message);
      this.view.refetchData();
    } catch (error) {
      this.view.showError(error);
    }
  }
 
}
export default OBForApprovalPresenter;
